import type { FC } from "react";
import { Link } from "react-router-dom";

import { SubscribeButton } from "@/components/form";
import ArrowNarrowLeft from "@/icons/Solid/arrow-narrow-left";
import type { AnyReactFormApi } from "@/types/form";

type LoginReturnFooterProps = {
  title?: string;
  beforeTitle?: string;
  Subscribe: AnyReactFormApi["Subscribe"];
};

const LoginReturnFooter: FC<LoginReturnFooterProps> = ({
  title,
  beforeTitle,
  Subscribe,
}) => {
  return (
    <div className="flex flex-col gap-8">
      {beforeTitle ? (
        <p className="flex justify-center">{beforeTitle}</p>
      ) : null}
      <SubscribeButton Subscribe={Subscribe}>
        {title ?? "Réinitialiser le mot de passe"}
      </SubscribeButton>
      <Link to="/connexion" className="flex justify-center items-center gap-1">
        <ArrowNarrowLeft />
        <p className="text-sm text-semibold bg-[linear-gradient(-90deg,_#2C00B7_0%,_#B5307D_67%,_#FC9CAC_100%)] bg-clip-text text-transparent">
          Retour à la connexion
        </p>
      </Link>
    </div>
  );
};

export default LoginReturnFooter;
